/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ReplyRequestBodyDoc } from './replyRequestBodyDoc';
import type { ReplyRequestType } from './replyRequestType';

/**
 * ``POST /inbox/threads/{thread_id}/replies`` body.
 *
 * Validation rules per spec §11 "Validation":
 *
 * - ``body_doc`` must be a non-empty TipTap doc (text-bearing).
 * - ``cc`` / ``bcc`` capped at 50 entries each (RFC-compatible
 *   headers — not a hard limit but a sanity guard).
 * - ``scheduled_for_at`` must be ``> now()`` and ``<= now() + 90
 *   days``; ``timezone`` is required when ``scheduled_for_at`` is
 *   set so the recruiter sees the local-time confirmation.
 */
export interface ReplyRequest {
  body_doc: ReplyRequestBodyDoc;
  subject?: string | null;
  type?: ReplyRequestType;
  reply_to_message_id?: string | null;
  /** @maxItems 50 */
  cc?: string[];
  /** @maxItems 50 */
  bcc?: string[];
  include_sender_signature?: boolean;
  scheduled_send_at?: string | null;
  timezone?: string | null;
  /**
     * @minLength 8
     * @maxLength 128
     */
  idempotency_key: string;
}
